//====================================================
//  Function: Tabs
//====================================================
function fn_components_tabs(){
	if ($( '.js-tabs-group' ).length){
		$( '.js-tabs-group .js-tabs-list-item' ).click(function() {
			var inst = $(this);
			var thisId = inst.attr( 'id' );
			var thisTabs = $(this).closest( '.js-tabs-group' );

			if(thisId == 'undefined'){
				return false;
			}
			
			if (!inst.hasClass( class_active )){
				thisTabs.find( '.js-tabs-list-item.' + class_active + '' ).removeClass( class_active );
				$(this).closest( '.js-tabs-list-item').addClass( class_active );
				thisTabs.find( '.js-tabs-content .js-tabs-content-item.' + class_active + '' ).removeClass( class_active );
				thisTabs.find( '.js-tabs-content .js-tabs-content-item[data-id="'+ thisId + '"]' ).addClass( class_active );
			}
			return false;
		});
	}

	if ($( '.js-tabs-group-hover' ).length){
		$( '.js-tabs-group-hover .js-tabs-list-item' ).hover(
			function() {
				var inst = $(this);
				var thisId = inst.attr( 'id' );
				var thisDataId = inst.data( 'id' );
				var elementNumber = inst.index();
				var thisTabs = $(this).closest( '.js-tabs-group-hover' );

				if(thisId == 'undefined'){
					return false;
				}
				
				if (!inst.hasClass( class_active )){
					thisTabs.find( '.js-tabs-list-item.' + class_active + '' ).removeClass( class_active );
					$(this).closest( '.js-tabs-list-item').addClass( class_active );
					thisTabs.find( '.js-tabs-content .js-tabs-content-item.' + class_active + '' ).removeClass( class_active );
					thisTabs.find( '.js-tabs-content .js-tabs-content-item[data-id="'+ thisId + '"]' ).addClass( class_active );
					
					$( '.timeline-line-item' ).removeClass( class_active );

					$( '.js-slider-history-image' ).slick( 'slickGoTo', thisDataId - 1);

					$( '.timeline-line-item' ).each(function(index){
						if (index < elementNumber){
							$('.timeline-line-item-' + index + '').addClass( class_active );
						}
					});
				}

			}
			// , function() {
			// 	var inst = $(this);
			// 	var thisId = inst.attr( 'id' );
			// 	var thisTabs = $(this).closest( '.js-tabs-group-hover' );
			// 	thisTabs.find( '.js-tabs-list-item.' + class_active + '' ).removeClass( class_active );
			// 	thisTabs.find( '.js-tabs-content .js-tabs-content-item.' + class_active + '' ).removeClass( class_active );
			// 	$( '.timeline-line-item' ).removeClass( class_active );

			// 	thisTabs.find( '.js-tabs-list-item.timeline-item-1' ).addClass( class_active );
			// 	thisTabs.find( '.js-tabs-content .js-tabs-content-item[data-id="tab-1"]' ).addClass( class_active );
			// }
		);
	}
}
